

  import { Component, Vue } from 'vue-property-decorator'
  import axios from 'axios';
  import { GF } from '../helpers/gf';
  import { FILTERS } from "../helpers/filters";
  import "../helpers/helpers";

  import WrsLabel from './wrsControls/WrsLabel.vue';
  import WrsAlert from './wrsControls/WrsAlert.vue';
  import WrsSecurityDialog from './wrsControls/WrsSecurityDialog.vue';
  import WrsWizardStepHeader from './wrsControls/WrsWizardStepHeader.vue';
  import WrsWizardStepButtons from './wrsControls/WrsWizardStepButtons.vue';
  import WrsSearchButtons from './wrsControls/WrsSearchButtons.vue';

  import WrsViSelect from './wrsControls/viControls/WrsViSelect.vue';
  import WrsViText from './wrsControls/viControls/WrsViText.vue';
  import WrsViTextArea from './wrsControls/viControls/WrsViTextArea.vue';
  import WrsViDate from './wrsControls/viControls/WrsViDate.vue';
  import WrsViNumeric from './wrsControls/viControls/WrsViNumeric.vue';
  import WrsViCheckbox from './wrsControls/viControls/WrsViCheckbox.vue';
  import WrsViLabel from './wrsControls/viControls/WrsViLabel.vue';

  import WrsFee from './wrsControls/WrsFee.vue';

  import { IS_PRODUCTION_ENVIRONMENT, IS_VUEJS_ENVIRONMENT } from '../../olsStateManagement/helpers/constants';
  import { userService } from '../../olsStateManagement/services/devAuth.service';
  import AuthService from '../../olsStateManagement/services/auth.service';
  import {DEFAULT_ROOT_URL} from '../../olsStateManagement/helpers/constants'

  const authService = new AuthService();

  @Component({
    components: {
      'wrs-alert': WrsAlert,
      'wrs-security-dialog': WrsSecurityDialog,
      'wrs-wizard-step-header': WrsWizardStepHeader,
      'wrs-wizard-step-buttons': WrsWizardStepButtons,
      'wrs-search-buttons': WrsSearchButtons,
      'wrs-vi-select': WrsViSelect,
      'wrs-vi-text': WrsViText,
      'wrs-vi-textarea': WrsViTextArea,
      'wrs-vi-numeric': WrsViNumeric,
      'wrs-vi-checkbox': WrsViCheckbox,
      'wrs-label': WrsLabel,
      'wrs-vi-date': WrsViDate,
      'wrs-fee': WrsFee,
      'wrs-vi-label': WrsViLabel,
    },
  })

  export default class App extends Vue {
    public VM: any = {};

    public reviewPanel: any = [0, 1, 2, 3, 4, 5, 6, 7];

    public STEPIDS: any = {
      stepVehicle: 1,
      stepAddVehicle: 2,
      stepPeriod: 3,
      stepPreview: 4,
      stepFinish: 5,
    };

    public currentOlsUser: any = {};
    public clientData: any = {};

    public isAuthorized: boolean = false;
    public emailVerified: boolean = false;
    public userName: string = ""

    public loader: any = {
      loaded: false,
      loadedNoError: false,
      loading: false
    };
    public modelPermit: any = {
      vehicleConfigurationId: 0
    };

     // Mobile funcions
    public isMobile: boolean = false;
    onResize() {
      if (window.innerWidth < 769)
        this.isMobile = true;
      else
        this.isMobile = false;
    }

    public expandedRows: any = [];
    public mobileRowExpanded: boolean = false;
    expandRow(index: any){ 
      const indexOfRow = this.expandedRows.indexOf(index)
      if(indexOfRow > -1){
        this.mobileRowExpanded = false;
        this.expandedRows.splice(indexOfRow,1);
        return;
      }
      this.mobileRowExpanded = true;
      this.expandedRows.push(index);
    }

    //created() {
    //  if (!IS_PRODUCTION_ENVIRONMENT && IS_VUEJS_ENVIRONMENT) {
    //    import('../../olsStateManagement/css/olsOverrideDev.scss')
    //  }
    //}

    mounted() {
      this.startWizard();
    }
    startWizard() {
      this.VM.currentStepId = this.STEPIDS.stepVehicle;
      this.loader.loaded = false;
      this.loader.loadedNoError = false;
      this.loader.loading = false;

      if (!IS_PRODUCTION_ENVIRONMENT && IS_VUEJS_ENVIRONMENT) {
        let userData = userService.getUser();
        userData
          .then((result) => {
            this.clientData = JSON.parse(JSON.stringify(result));
            this.loadData();
            this.isAuthorized = this.clientData.isLoggedIn;
          });
      } else {

        authService.getUser()
          .then((user:any) => {
            if(user) {
              this.emailVerified = authService.emailVerified();

              if(user.profile.email_verified) {
                this.isAuthorized = authService.isAuthorized();

                if(this.isAuthorized) {

                  this.userName = user.profile.name != null ? user.profile.name : user.profile.email;

                  let pOlsUser = sessionStorage.getItem('olsUser')
                  if(pOlsUser){
                    let olsUser = JSON.parse(pOlsUser);

                    axios
                      .get("olsUserProfile/getUserDefaultClient/" + olsUser.olsUserId + '/0/true',)
                        .then(response => {
                          this.clientData = response.data;
                          this.loadData()
                      })
                      .catch(error => console.log(error))

                  }
                }
                else {
                  authService.logout();
                }
              }
              // else in store.js user is redirected to email-not-verified page!
            }
          })
          .catch(error => console.log(error))
          .finally(() => {
            this.loader.loading = false;
            this.loader.loaded = true;
          })

      }
    }


    public async loadData() {
      this.selectedVehicle = {};
      this.loader.loading = true;

      axios
        .get('permits/initViewModelMtp/' + this.clientData.olsUserId + '/' + this.clientData.clientId)
        .then(response => { this.VM = response.data; })
        .catch(error => console.log(error))
        .finally(() => {
          this.loader.loading = false;
          this.loader.loaded = true;
          this.loader.loadedNoError = !this.VM.securityError.hasError;
          if (this.loader.loadedNoError) {
            this.findVehicle();
          }
        });
    }

    //All Steps Related
    getStepDataRequest(stepId: number, initType: any, isFinish: boolean) {
      let dr = {
        clientId: this.clientData.clientId,
        olsUserId: this.clientData.olsUserId,
        regId: 0,
        regExpiry: "",
        stepId: stepId,
        initType: initType,
        id: 0,
        mtFromDate: "",
        mtUnitNumber: "",
        periodId: 0,
        requestNotes: this.VM.requestNotes.value,
        onAccounts: [] as any,
        ireByPlate: "",
        ireByVin: "",
        isNewOotVehicle: false,
        newOotVehicle: {} as any,
      };

      if (initType == 77) {
        //IRE Search NT ZD4SBC00294001276, 10316
        dr.ireByPlate = this.VM.irePlateNumber.value.toString().toUpperCase();
        dr.ireByVin = this.VM.ireVin.value.toString().toUpperCase();
      }

      if (initType != 77) {
        if (stepId > this.STEPIDS.stepVehicle) {
          dr.regId = this.selectedVehicle.registrationId;
          dr.regExpiry = this.selectedVehicle.expiryDate;
          dr.mtUnitNumber = this.selectedVehicle.unitNumber;
        }

        if (stepId >= this.STEPIDS.stepAddVehicle && this.newOotVehicleIsOk()) {
          let newOotVehicle = {
            vehicleTypeId: this.VM.avVehicleType.value,
            vehicleStyleId: this.VM.avVehicleStyle.value,
            vehicleColorId: this.VM.avVehicleColor.value,
            unitNumber: this.VM.avUnitNumber.value,
            year: this.VM.avYear.value,
            makeId: this.VM.avMake.value,
            modelId: this.VM.avModel.value,
            effectiveDate: FILTERS.dateToString(this.VM.avEffectiveDate.value),
            expiryDate: FILTERS.dateToString(this.VM.avExpiryDate.value),
            plateNumber: this.VM.avPlateNumber,
            vin: this.VM.avVin,
          }
          dr.newOotVehicle = newOotVehicle;
          dr.isNewOotVehicle = true;
        }

        dr.periodId = this.VM.period.value;
        dr.mtFromDate = FILTERS.dateToString(this.VM.effectiveDate.value);

        if (stepId > this.STEPIDS.stepPeriod) {
          dr.mtUnitNumber = this.VM.unitNumber.value;
        }

        if (isFinish) { dr.initType = this.isAddToCart ? 99 : 88; }
      }

      return dr;
    }

    newOotVehicleIsOk() {
      if (!this.VM.ireSearchExecuted || !this.VM.isNewOotVehicle) return false;

      return !this.VM.avVehicleType.hasError &&
        !this.VM.avVehicleStyle.hasError &&
        !this.VM.avVehicleColor.hasError &&
        !this.VM.avMake.hasError &&
        !this.VM.avModel.hasError &&
        !this.VM.avEffectiveDate.hasError &&
        !this.VM.avExpiryDate.hasError &&
        !this.VM.avUnitNumber.hasError &&
        !this.VM.avYear.hasError;
    }

    canGoToNextStep(currentStepId: number) {
      if (this.VM.runtimeError.hasError) return false;

      if (currentStepId == this.STEPIDS.stepVehicle) {
        var cnt = this.vehicleList.filter((item: any) => item.isSelected == true);
        return cnt.length > 0;
      }
      else if (currentStepId == this.STEPIDS.stepAddVehicle) {
        return this.newOotVehicleIsOk();
      }
      else if (currentStepId == this.STEPIDS.stepPeriod) {
        return this.canRecalculateMt && !this.VM.runtimeError.hasError;
      }
      else if (currentStepId == this.STEPIDS.stepPreview) {
        return !this.VM.stepPreview.alert.hasAny && this.VM.disclamer?.value;
      }

      return false;
    }
    loadNextStep(stepId: number) {
      if (!this.canGoToNextStep(stepId)) return;

      if (stepId == this.STEPIDS.stepVehicle) {
        this.VM.currentStepId = this.STEPIDS.stepPeriod;
        this.recalculateMt();
      }
      else if (stepId == this.STEPIDS.stepAddVehicle) {
        this.VM.currentStepId = this.STEPIDS.stepPeriod;
        this.recalculateMt();
      }
      else if (stepId == this.STEPIDS.stepPeriod) {
        this.VM.currentStepId = this.STEPIDS.stepPreview;

        //calculate everything and do a preview
        this.loader.loading = true;
        let dr = this.getStepDataRequest(this.STEPIDS.stepPreview, 2, false);

        axios
          .post('permits/getMtpStepData', dr)
          .then(response => {
            this.VM.requiresApproval = response.data.requiresApproval;
            this.VM.approvalList = response.data.approvalList;
            this.VM.calculatedFees = response.data.calculatedFees;
            this.VM.conditions = response.data.conditions;
            this.VM.permitCart = response.data.permitCart;
            this.VM.disclamer = response.data.disclamer;
            this.VM.mt = response.data.mt;
          })
          .catch(error => console.log(error))
          .finally(() => {
            this.loader.loading = false;
          });
      }
    }

    //#region Find Vehicle Step
    public selectedVehicle: any = {};
    public vehicleList: any = [];

    //getters
    get findVehicleHideDefaultFooter() {
      if (this.vehicleList) {
        return this.vehicleList.length < 10;
      }
      return true;
    }

    //methods
    searchParamChanged() {
      this.selectedVehicle = {};
      this.vehicleList = [];
      GF.clearAlert(this.VM.stepVehicle.alert);
    }

    findVehicle() {
      GF.setAlertError(this.VM.stepVehicle.alert, "");
      let provinceId = this.VM.jurisdiction.value;
      let plateNumber = '%20';
      if (this.VM.plateNumber.value != "") plateNumber = this.VM.plateNumber.value;

      let unitNumberSearch = '%20';
      if (this.VM.unitNumberSearch.value != "") unitNumberSearch = this.VM.unitNumberSearch.value;

      this.loader.loading = true;

      axios
        .get('permits/vehiclesearch/' + this.clientData.olsUserId + '/' + this.clientData.clientId + '/' + provinceId + '/' + plateNumber + '/' + unitNumberSearch)
        .then(response => (this.vehicleList = response.data))
        .catch(error => console.log(error))
        .finally(() => {
          this.loader.loading = false;
          if (this.vehicleList.length == 0) {
            GF.setAlertError(this.VM.stepVehicle.alert, this.VM.wizardMessages.VehicleSearchNoneFound);
          }
          else {
            GF.setAlertError(this.VM.stepVehicle.alert, "");
          }
        });
    }
    clearFindVehicle() {
      this.selectedVehicle = {};
      GF.setAlertError(this.VM.stepVehicle.alert, "");

      this.VM.jurisdiction.value = this.clientData.provinceId;
      this.VM.plateNumber.value = "";
      this.VM.unitNumberSearch.value = "";

      this.findVehicle();
    }
    selectVehicle(id: number) {
      var index, len;
      this.selectedVehicle = {};

      for (index = 0, len = this.vehicleList.length; index < len; ++index) {
        if (this.vehicleList[index].id == id) {
          this.vehicleList[index].isSelected = true;
          this.selectedVehicle = this.vehicleList[index];
        }
        else
          this.vehicleList[index].isSelected = false;
      }
    }
    getVehicleTableHeaders() {
      return [
        { text: '', value: 'isSelected', sortable: false, width: '50px' },
        { text: this.VM.wizardLabels.PlateNo, value: 'plateNumber', align: 'start', sortable: false, width: '' }, //120px
        { text: this.VM.wizardLabels.VehicleInfo, value: 'vehicleInfoGrid', sortable: false, width: '' }, //400px
        { text: this.VM.wizardLabels.ExpiryDate, value: 'expiryDate', sortable: false, width: '' }, //120px
        { text: this.VM.wizardLabels.Details, value: 'data-table-expand', sortable: false },
      ];
    }
    //#endregion

    //#region Add Vehicle Step
    get canAddVehicle() {
      if (!this.loader.loaded) return false;
      if (this.VM.runtimeError.hasError) return false;
      if (this.VM.jurisdiction.hasError) return false;
      return this.VM.jurisdiction.value != this.VM.homeProvinceId;
    }
    get ireCheckDisabled() {
      if (this.VM.currentStepId != this.STEPIDS.stepAddVehicle) return false;
      if (!this.VM.isNewVehicle) return false;

      return this.VM.irePlateNumber.hasError || this.VM.ireVin.hasError;
    }
    ireCheck() {
      this.loader.loading = true;
      this.VM.currentStepId = this.STEPIDS.stepAddVehicle;
      let dr = this.getStepDataRequest(this.STEPIDS.stepAddVehicle, 77, false); //IreSearch

      axios
        .post('permits/getMtpStepData', dr)
        .then(response => {
          this.VM.avVehicleType = response.data.avVehicleType;
          this.VM.avVehicleStyle = response.data.avVehicleStyle;
          this.VM.avVehicleColor = response.data.avVehicleColor;

          this.VM.avUnitNumber = response.data.avUnitNumber;
          this.VM.avYear = response.data.avYear;
          this.VM.avMake = response.data.avMake;
          this.VM.avModel = response.data.avModel;
          this.VM.avEffectiveDate = response.data.avEffectiveDate;
          this.VM.avExpiryDate = response.data.avExpiryDate;

          this.VM.avPlateNumber = response.data.avPlateNumber;
          this.VM.avVin = response.data.avVin;

          this.VM.ireSearchExecuted = response.data.ireSearchExecuted;
          this.VM.isNewOotVehicle = response.data.isNewOotVehicle;

          this.VM.stepAddVehicle.alert = response.data.stepAddVehicle.alert;
        })
        .catch(error => console.log(error))
        .finally(() => {
          this.loader.loading = false;
        });
    }

    clearIreCheck() {
      this.VM.irePlateNumber.value = "";
      this.VM.ireVin.value = "";
      this.VM.ireSearchExecuted = false;
      this.VM.isNewOotVehicle = false;
      GF.clearAlert(this.VM.stepAddVehicle.alert);
    }

    loadAddVehicleStep() {
      this.loader.loading = true;
      this.VM.currentStepId = this.STEPIDS.stepAddVehicle;
      let dr = this.getStepDataRequest(this.STEPIDS.stepAddVehicle, 1, false);

      axios
        .post('permits/getMtpStepData', dr)
        .then(response => {
          this.VM.irePlateNumber = response.data.irePlateNumber;
          this.VM.ireVin = response.data.ireVin;
          this.VM.isNewVehicle = true;
        })
        .catch(error => console.log(error))
        .finally(() => {
          this.loader.loading = false;
        });
    }

    avMakeChanged() {
      this.loader.loading = true;
      let makeId = 0;
      if (!this.VM.avMake.hasError) makeId = this.VM.avMake.value;

      axios
        .get('permits/GetVehicleModels/' + makeId)
        .then(response => {
          this.VM.avModel = response.data;
        })
        .catch(error => console.log(error))
        .finally(() => {
          this.loader.loading = false;
        });
    }

    public avDatesCheckResult: any = [];
    get avEffectiveDateExternalError() {
      if (this.avDatesCheckResult.length < 1) return "";

      return this.avDatesCheckResult[0].errorMessage;
    }
    get avExpiryDateExternalError() {
      if (this.avDatesCheckResult.length < 2) return "";

      return this.avDatesCheckResult[1].errorMessage;
    }

    checkAvDates() {
      let dr = {
        dates: [] as any,
      };

      let fromDate = {
        "date1Label": this.VM.avEffectiveDate.label,
        "date1Value": this.VM.avEffectiveDate.value,
        "date2Label": this.VM.avExpiryDate.label,
        "date2Value": this.VM.avExpiryDate.value,
        "canBeInthePast": true,
        "canBeIntheFuture": false,
        "canBeBeforeDate2": true,
        "canBeAfterDate2": false,
        "errorMessage": ""
      }
      dr.dates.push(fromDate);

      let toDate = {
        "date1Label": this.VM.avExpiryDate.label,
        "date1Value": this.VM.avExpiryDate.value,
        "date2Label": this.VM.avEffectiveDate.label,
        "date2Value": this.VM.avEffectiveDate.value,
        "canBeInthePast": false,
        "canBeIntheFuture": true,
        "canBeBeforeDate2": false,
        "canBeAfterDate2": true,
        "errorMessage": ""
      }
      dr.dates.push(toDate);

      axios
        .post('lookups/checkdates', dr)
        .then(response => {
          this.avDatesCheckResult = response.data.dates;
        })
        .catch(error => console.log(error))
        .finally(() => {
          this.loader.loading = false;
        });
    }

    //#endregion

    //#region Multi Trip Permit
    //getters
    get canRecalculateMt() {
        return !this.VM.effectiveDate.hasError && !this.VM.unitNumber.hasError && !this.VM.period.hasError;
    }
    get canRecalculateMtDates() {
        return !this.VM.effectiveDate.hasError && !this.VM.unitNumber.hasError;
    }

    //methods
    mtpDataPeriodChanged() {
      if (this.VM.period.value == 0) return;

      var selectedPeriod = this.VM.period.items.filter((item: any) => item.id == this.VM.period.value);
      if (selectedPeriod.length == 0) return;
      this.VM.expiryDate.value = selectedPeriod[0].rec;
    }

    mtpDataDateChanged() {
      this.recalculateMt();
    }

    public mtpDatesCheckResult: any = [];
    get mtpEffectiveDateExternalError() {
      if (this.mtpDatesCheckResult.length < 1) return "";

      return this.mtpDatesCheckResult[0].errorMessage;
    }

    recalculateMt() {
      var dr = this.getStepDataRequest(this.STEPIDS.stepPeriod, 2, false);

      axios
        .post('permits/getMtpStepData', dr)
        .then(response => {
          this.VM.effectiveDate = response.data.effectiveDate;
          this.VM.expiryDate = response.data.expiryDate;
          this.VM.unitNumber = response.data.unitNumber;
          this.VM.period = response.data.period;

          this.VM.runtimeError = response.data.runtimeError;
        })
        .catch(error => console.log(error))
        .finally(() => {
          this.loader.loading = false;
        });
    }
    //#endregion


    //#region Preview Step
    //getters
    //getters
    get showUnitNumberOnPreview() {
      return this.VM.mt.unitNumber != null && this.VM.mt.unitNumber != '';
    }

    get isAddToCart() {
      if (this.VM.currentStepId != this.STEPIDS.stepPreview) return false;
      if (this.VM.requiresApproval) return false;
      return true;
    }

    get finalText() {
      if (this.VM.currentStepId != this.STEPIDS.stepPreview) return "";
      if (this.VM.requiresApproval) return this.VM.wizardLabels.SendForApproval;
      return this.VM.wizardLabels.AddToShoppigCart;
    }

    //methods
    addToCartOrSendForReview() {
      //sned for review or add to cart
      this.loader.loading = true;
      let dr = this.getStepDataRequest(this.STEPIDS.stepPreview, 2, true);

      for (var i = 0; i < this.VM.permitCart.calculatedFees.length; i++) {
        if (this.VM.permitCart.calculatedFees[i].onAccountId != null && this.VM.permitCart.calculatedFees[i].onAccountId > 0) {
          dr.onAccounts.push({
            id: this.VM.permitCart.calculatedFees[i].onAccountId,
            permitCartItemId: this.VM.permitCart.calculatedFees[i].permitCartItemId,
            text: "",
          });

        }
      }
      axios
        .post('permits/getMtpStepData', dr)
        .then(response => {
          this.VM.currentStepId = this.STEPIDS.stepFinish;
          this.VM.stepFinish.alert = response.data.stepFinish.alert;
          this.VM.jumpToCart = response.data.jumpToCart;
        })
        .catch(error => console.log(error))
        .finally(() => {
          if (this.VM.jumpToCart) {
            this.redirectToFullURL(this.VM.shoppingCartWebAddress);
          }
          this.loader.loading = false;
        });
    }


    redirectToUrl(url: string) {
      return window.location.href = DEFAULT_ROOT_URL + url;
    }

    redirectToFullURL(url:string) {
      return window.location.href = url;
    }

    //#endregion
  }
